import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { PerfectScrollbarConfigInterface, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { BaseComponent } from 'src/app/_base/base.component';
import { GallaryType, UsersTypes } from 'src/app/_enums';
import { StageSelectionClass, SystemUserType, Users } from 'src/app/_models';
import { ClassesService, GallaryService, UserService } from 'src/app/_services';
import { SchoolClass } from 'src/app/templates/models/schoolClass.interface';
import { Section } from 'src/app/templates/models/section.interface';
import { Stage } from 'src/app/templates/models/stage.interface';

@Component({
  selector: 'app-gallery-settings',
  templateUrl: './gallery-settings.component.html',
  styleUrls: ['./gallery-settings.component.scss']
})
export class GallerySettingsComponent extends BaseComponent implements OnInit {
  @Input('formSubmitAttempt')
  formSubmitAttempt: boolean = false;
  @Input('typeReader')
  typeReader: number;
  @Input('settingsForm')
  settingsForm: FormGroup;
  // @Output('settingsFormEmitter')
  // settingsFormEmitter = new EventEmitter();
  @Input('photoName')
  photoName: FormControl;
  @Input('showGallery')
  showGallery: boolean = true;
  @Input('visibleTo')
  visibleTo: FormControl;
  @Input('userTypeId')
  userTypeId: FormControl;
  @Input('classId')
  classId: FormControl;
  @Input('sectionId')
  sectionId: FormControl;
  @Input('departmentId')
  departmentId: FormControl;
  @Input('filterSearch')
  filterSearch: FormControl;
  @Input('usersTypesList')
  usersTypesList: SystemUserType[] = [];
  classesList: SchoolClass[] = [];
  sectionsList: any[] = [];
  departmentsList: any[] = [];
  @Input('filterList')
  filterList: Users[] = [];
  @Input('resultList')
  resultList: Users[] = [];
  @Output('resultListEmitter')
  resultListEmitter = new EventEmitter();
  @ViewChild(PerfectScrollbarDirective)
  directiveRef?: PerfectScrollbarDirective;
  usersTypes = UsersTypes;
  // @Output()
  // classIdEmitter = new EventEmitter();
  // @Output()
  // sectionIdEmitter = new EventEmitter();
  // @Output()
  // departmentIdEmitter = new EventEmitter();
  // @Output()
  // userTypeIdEmitter = new EventEmitter();
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    suppressScrollY: false
  };
  subscription: Subscription;
  stages: Stage[];
  classes: SchoolClass[] = [];
  sections: Section[] = [];
  stageAndClasses: StageSelectionClass = new StageSelectionClass();
  isActive: boolean;
  orginalfilterList: Users[];
  constructor(private galleryService: GallaryService, private _classesService: ClassesService, private _userService: UserService) {
    super();
  }

  ngOnInit() {
    this.orginalfilterList = [];
  }
  nameInit(): string {
    if (this.typeReader === GallaryType.photo) return 'PhotoName';
    if (this.typeReader === GallaryType.album) return 'AlbumName';
    if (this.typeReader === GallaryType.yearbook) return 'YearbookName';
    return 'Unknown Type';
  }

  resultSearchInit() {
    if (this.userTypeId.value === UsersTypes.Student) return 'SearchInStudents';
    if (this.userTypeId.value === UsersTypes.Guardian) return 'SearchInTeachers';
    if (this.userTypeId.value === UsersTypes.Teacher) return 'SearchInTeachers';
    // if (this.userTypeId.value === UsersTypes.AcademicCoordinator) return 'SearchInAdministrators';
    // if (this.userTypeId.value === UsersTypes.AcademicCoordinator) return 'SearchInEmployees';
    // if (this.userTypeId.value === UsersTypes.FloorManager) return 'SearchInManagers';
    // if (this.userTypeId.value === UsersTypes.Mentor) return 'SearchInMentors';
    // if (this.userTypeId.value === UsersTypes.Owner) return 'SearchInOwners';
    // if (this.userTypeId.value === UsersTypes.SchoolHead) return 'SearchInSupervisors';
    return 'Unknown Type';
  }

  userTypeChanged(): void {
    this.directiveRef.scrollToTop();
    this.directiveRef.update();
    this.classId.setValue(-1);
    this.sectionId.setValue(-1);
    this.filterList.length = 0;
    if (this.userTypeId.value === UsersTypes.Student || this.userTypeId.value === UsersTypes.Guardian) this.getStagesWithClasses();
    else
      this._userService.GetStaffUsers(this.userTypeId.value).subscribe((data: Users[]) => {
        this.filterList = data;
        this.orginalfilterList = _.cloneDeep(data);
        this.removeSelectedItems();
      });
    // this.userTypeIdEmitter.emit(this.userTypeId.value);
  }

  classIdChanged(classId): void {
    this.directiveRef.scrollToTop();
    this.directiveRef.update();
    this.sections = [];
    // this.students = [];
    if (!classId) {
      return;
    }

    this.isActive = true;

    this._classesService.getSectionsByClassId(classId).subscribe(
      (data: Section[]) => {
        this.isActive = false;
        if (data.length > 0) {
          this.sections = data;
        }
      },
      () => (this.isActive = false)
    );
  }

  sectionIdChanged(sectionId): void {
    this.directiveRef.scrollToTop();
    this.directiveRef.update();
    if (this.sectionId.value !== -1)
      if (this.userTypeId.value === UsersTypes.Student)
        this._userService.$getStudentsBySectionId(this.sectionId.value).subscribe((data: Users[]) => {
          this.filterList = data;
          this.orginalfilterList = _.cloneDeep(data);
          this.removeSelectedItems();
        });

    if (this.userTypeId.value === UsersTypes.Guardian)
      this._userService.getGuardiansBySectionId(this.sectionId.value).subscribe((data: Users[]) => {
        this.filterList = data;
        this.orginalfilterList = _.cloneDeep(data);
        this.removeSelectedItems();
      });
    // this.sectionIdEmitter.emit(this.sectionId.value);
  }

  filterChanged(index: number): void {
    this.resultList = [this.filterList[index], ...this.resultList];
    this.filterList.splice(index, 1);
    this.resultListEmitter.emit(this.resultList);
  }

  resultClicked(index: number): void {
    this.resultList.splice(index, 1);
    this.removeSelectedItems();
    this.resultListEmitter.emit(this.resultList);
  }

  removeSelectedItems(): void {
    this.filterList = _.cloneDeep(this.orginalfilterList);

    this.resultList.forEach(element => {
      const index = this.filterList.findIndex(item => item.id === element.id);
      if (index !== -1) this.filterList.splice(index, 1);
    });
  }

  getStagesWithClasses() {
    this._classesService.getStagesAndClasses(false, null, null).subscribe((data: StageSelectionClass) => {
      if (!data) return;

      this.stageAndClasses = data;
      const stageGroup = this.stageAndClasses.stages;
      const classes = this.stageAndClasses.classes;
      const isStageEnabled = this.stageAndClasses.isStageEnabled || false;

      this.stages = stageGroup;
      this.classes = classes;

      if (isStageEnabled && this.stageAndClasses.stages.length > 0) {
        stageGroup.map(s => (s.classes = classes.filter(c => c.stageId === s.stageId)));
        if (classes.filter(c => !c.stageId).length > 0) {
          const unknownStages: Stage = {
            stageName: 'UnKnown',
            stageId: -1,
            classes: classes.filter(c => !c.stageId)
          };
          stageGroup.push(unknownStages);
        }
      } else {
        this.classes = this.stageAndClasses.classes;
      }
    });
  }

  isStageView() {
    return this.stageAndClasses.isStageEnabled && this.stageAndClasses.stages.length > 0;
  }
}
